<template>
  <BaseModal class="order-modal" v-model="isOpenModal">
    <div class="order-view" v-if="orderFull && !loading">
      <div class="header">
        <div class="info">
          {{ orderFull.source }} - {{ orderFull.salesman }} -
          {{ orderFull.orderKey }}
          <span>{{ orderFull.departamentoNombre }}</span>
        </div>
      </div>
      <div
        v-if="orderFull.fulfillmentStatus == 0"
        class="h-10 bg-warning text-white w-full text-center py-2"
      >
        Stock incomplete on order creation
      </div>
      <div
        id="head-buttons"
        class="w-full flex justify-end px-4 py-1 items-center gap-2"
      >
        <button @click="createDispatchReceipt" class="dark-button">
          Add dispatch receipt
        </button>
        <OrderFlagButton
          :orderUUID="orderFull.uuid"
          :history="orderFull.flagHistory"
          :flag="orderFull.flag == 1"
          @flagAdded="getOrder"
        />
        <a target="_blank" :href="printOrderUrl" class="h-6 w-6">
          <img
            class="w-full h-full"
            src="@/assets/icons/printer.svg"
            alt="print"
          />
        </a>
        <button
          v-if="orderFull.status == 'awaiting_shipment'"
          @click="changeOrderStatus('shipped')"
          class="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
        >
          Mark as Shipped
        </button>
        <button
          v-if="orderFull.status == 'awaiting_shipment'"
          @click="changeOrderStatus('cancelled')"
          class="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700"
        >
          Cancel Order
        </button>
        <button @click="showOrderOptions = true" class="dark-button ml-4">
          Options
        </button>
        <div
          ref="optionsBox"
          id="options-box"
          v-if="showOrderOptions"
          class="
            absolute
            top-10
            right-2
            z-50
            flex
            flex-col
            bg-gray-600
            text-white
            rounded-md
            py-10
            border-t
            border-b
            border-gray-200
            "
        >
          <div
            class="cursor-pointer ml-auto absolute top-2 right-2 rounded-full text-white bg-black w-6 h-6 flex justify-center items-center"
            @click="showOrderOptions = false"
          >
            x
          </div>
          <button class="list-button" @click="reverifyProducts()">
            Reverify products
          </button>
          <button class="list-button" @click="updateFromShipstation()">
            Update from ShipStation
          </button>
          <button class="list-button" @click="touchOrderAction()">
            Touch Order
          </button>
          <div
            class="border-t border-gray-500 mt-2 pt-2 px-4 text-gray-400 text-xs uppercase tracking-wide"
          >
            PrintNode
          </div>
          <button
            class="list-button"
            @click="printOrderWithPrintNode()"
            :disabled="printingOrder"
          >
            {{ printingOrder ? "Sending..." : "Print Invoice" }}
          </button>
          <!-- <button
            class="list-button"
            @click="markOrderShipped()"
            v-if="orderFull.status == 'awaiting_shipment'"
          >
            Mark order as shipped
          </button> -->
        </div>
      </div>
      <BaseOrderReceipts
        :orderUUID="orderUUID"
        :receipts="orderFull.receipts"
        :activeReceiptId.sync="activeReceiptId"
      ></BaseOrderReceipts>
      <div style="padding: 5px 10px;">
        <OrderFlagData
          :orderUUID="orderFull.uuid"
          :history="orderFull.flagHistory"
          :flag="orderFull.flag == 1"
          @flagAdded="getOrder"
        />
      </div>
      <div class="content" v-if="orderFull">
        <div class="box">
          <div class="box-header">
            <div class="flex justify-between items-center">
              <span>Address</span>
              <div class="flex gap-2">
                <button
                  @click="activeAddressTab = 'shipping'"
                  :class="[
                    'tab-button',
                    { active: activeAddressTab === 'shipping' }
                  ]"
                >
                  Shipping
                </button>
                <button
                  @click="activeAddressTab = 'billing'"
                  :class="[
                    'tab-button',
                    { active: activeAddressTab === 'billing' }
                  ]"
                >
                  Billing
                </button>
              </div>
            </div>
          </div>
          <div class="box-content">
            <div v-if="activeAddressTab === 'shipping'" class="address-box">
              <table>
                <tbody>
                  <tr>
                    <td>Name</td>
                    <td>{{ orderFull.shippingAddress.name }}</td>
                  </tr>
                  <tr>
                    <td>Company</td>
                    <td>{{ orderFull.shippingAddress.company }}</td>
                  </tr>
                  <tr>
                    <td>Address</td>
                    <td>
                      {{ orderFull.shippingAddress.street1 }}
                      {{ orderFull.shippingAddress.street2 }}
                      {{ orderFull.shippingAddress.street3 }}
                    </td>
                  </tr>
                  <tr>
                    <td>City</td>
                    <td>{{ orderFull.shippingAddress.city }}</td>
                  </tr>
                  <tr>
                    <td>State</td>
                    <td>{{ orderFull.shippingAddress.state }}</td>
                  </tr>
                  <tr>
                    <td>Postal code</td>
                    <td>{{ orderFull.shippingAddress.postalCode }}</td>
                  </tr>
                  <tr>
                    <td>Country</td>
                    <td>{{ orderFull.shippingAddress.country }}</td>
                  </tr>
                  <tr>
                    <td>Phone</td>
                    <td>{{ orderFull.shippingAddress.phone }}</td>
                  </tr>
                </tbody>
              </table>
              <button
                @click="startEditAddress('shipping')"
                class="dark-button mt-4"
              >
                Edit Address
              </button>
              <div class="alert" v-if="orderFull.forwarder_address">
                <p>Forwarder address set, Please print receipt</p>
              </div>
            </div>
            <div v-else-if="activeAddressTab === 'billing'" class="address-box">
              <table v-if="orderFull.billingAddress">
                <tbody>
                  <tr>
                    <td>Name</td>
                    <td>{{ orderFull.billingAddress.name }}</td>
                  </tr>
                  <tr>
                    <td>Company</td>
                    <td>{{ orderFull.billingAddress.company }}</td>
                  </tr>
                  <tr>
                    <td>Address</td>
                    <td>
                      {{ orderFull.billingAddress.street1 }}
                      {{ orderFull.billingAddress.street2 }}
                      {{ orderFull.billingAddress.street3 }}
                    </td>
                  </tr>
                  <tr>
                    <td>City</td>
                    <td>{{ orderFull.billingAddress.city }}</td>
                  </tr>
                  <tr>
                    <td>State</td>
                    <td>{{ orderFull.billingAddress.state }}</td>
                  </tr>
                  <tr>
                    <td>Postal code</td>
                    <td>{{ orderFull.billingAddress.postalCode }}</td>
                  </tr>
                  <tr>
                    <td>Country</td>
                    <td>{{ orderFull.billingAddress.country }}</td>
                  </tr>
                  <tr>
                    <td>Phone</td>
                    <td>{{ orderFull.billingAddress.phone }}</td>
                  </tr>
                </tbody>
              </table>
              <p v-else class="text-gray-500">No billing address available</p>
              <button
                v-if="orderFull.billingAddress"
                @click="startEditAddress('billing')"
                class="dark-button mt-4"
              >
                Edit Address
              </button>
            </div>
          </div>
        </div>
        <div class="box">
          <div class="box-header">
            General Info
          </div>
          <div class="box-content">
            <div class="info-box">
              <table>
                <tbody>
                  <tr>
                    <td>
                      Customer Purchase order
                    </td>
                    <td>
                      <b>
                        {{ orderFull.purchaseOrder }}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      order number shipstation
                    </td>
                    <td>
                      <b>
                        {{ orderFull.orderNumber }}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Modalidad Venta
                    </td>
                    <td>
                      <b>
                        {{ orderFull.modalidadVentaId }}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Deposito_id
                    </td>
                    <td>
                      <b>
                        {{ orderFull.warehouseId }}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td>Printed</td>
                    <td>{{ orderFull.printed == 1 ? "Yes" : "No" }}</td>
                  </tr>
                  <tr>
                    <td>
                      Price Level
                    </td>
                    <td>
                      <b>
                        {{ orderFull.priceLevel }}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Order Status
                    </td>
                    <td>
                      <b>
                        {{ orderFull.status }}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Seller
                    </td>
                    <td>
                      <b>
                        {{ orderFull.salesman }}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Create Date
                    </td>
                    <td>
                      {{ orderFull.createDate }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Order Original Date
                    </td>
                    <td>
                      {{ orderFull.orderDate }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Shipping option
                    </td>
                    <td>
                      {{ orderFull.shippingCarrierRequested }}
                      <br />
                      {{ orderFull.shippingServiceRequested }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Email
                    </td>
                    <td>
                      {{ orderFull.customerEmail }}
                    </td>
                  </tr>
                  <tr>
                    <td>Payment Type</td>
                    <td>
                      <b>{{ orderFull.paymentType }}</b>
                    </td>
                  </tr>
                  <tr>
                    <td>Payment Fees</td>
                    <td>
                      <b>{{ orderFull.paymentFees }}</b>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Export Status
                    </td>
                    <td v-if="!processing">
                      <template v-for="(system, index) in systems">
                        <div
                          v-if="!OrderSystemStatus(system.uuid)"
                          :key="index"
                        >
                          <a
                            @click="sendToSystem(system.code)"
                            class="default small"
                            v-if="
                              orderFull.exportEnabled != 0 &&
                                orderFull.canBeInvoiced
                            "
                          >
                            Send To {{ system.name }} now
                          </a>
                          <span v-else-if="orderFull.exportEnabled == 0">
                            Export Disabled ({{ system.name }})
                          </span>
                          <br />
                          <a
                            @click="forceSentToSystem(system.uuid)"
                            class="regular"
                            v-if="orderFull.canBeInvoiced"
                          >
                            mark as sent to {{ system.name }}
                          </a>
                        </div>
                        <div v-else class="success-text" :key="`sent-${index}`">
                          Sent To {{ system.name }}
                          <br />
                          <a
                            @click="sendToSystem(system.code)"
                            v-if="
                              orderFull.exportEnabled != 0 &&
                                orderFull.canBeInvoiced
                            "
                            class="regular"
                          >
                            Resend to {{ system.name }}
                          </a>
                        </div>
                      </template>
                    </td>
                    <td v-else>
                      Processing
                    </td>
                  </tr>
                  <tr
                    v-if="
                      orderFull.exportEnabled == 0 && orderFull.canBeInvoiced
                    "
                  >
                    <td>
                      Export Disabled
                    </td>
                    <td>
                      <a
                        class="default small success"
                        @click="changeExportEnable(1)"
                      >
                        Enable Export
                      </a>
                    </td>
                  </tr>
                  <tr v-else-if="orderFull.exportEnabled == 1">
                    <td>
                      Export Enabled
                    </td>
                    <td>
                      <a class="default small" @click="changeExportEnable(0)">
                        Disable Export
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="box">
          <div class="box-header">
            Totals
          </div>
          <div class="box-content">
            <div class="info-box">
              <table>
                <tbody>
                  <tr>
                    <td>
                      Total Items
                    </td>
                    <td>${{ orderFull.productsTotalAmount }}</td>
                  </tr>
                  <tr>
                    <td>
                      Shipping Paid
                    </td>
                    <td>${{ orderFull.shippingPaid }}</td>
                  </tr>
                  <tr>
                    <td>
                      Tax Paid
                    </td>
                    <td>${{ orderFull.tax }}</td>
                  </tr>
                  <tr v-if="orderFull.discount > 0 || orderFull.discountCode">
                    <td>
                      Discount
                      <div class="text-xs text-gray-400">
                        <span v-if="orderFull.discountType === 'percentage'">% — {{ orderFull.discountPercentage }}%</span>
                        <span v-else>Fixed Amount</span>
                      </div>
                    </td>
                    <td>
                      ${{ orderFull.discount }}
                      <span v-if="orderFull.discountCode">({{ orderFull.discountCode }})</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Core
                    </td>
                    <td>${{ orderFull.core }}</td>
                  </tr>
                  <tr>
                    <td>
                      Total
                    </td>
                    <td>
                      <b>${{ orderFull.total }}</b>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Amount available for Shipping
                    </td>
                    <td
                      v-if="
                        orderFull.shippingPaid !== 0 &&
                          orderFull.amountAvailableShipping !== null
                      "
                    >
                      <b class="font-extrabold">
                        ${{ orderFull.amountAvailableShipping }}
                      </b>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="product-box">
          <div class="box-header flex justify-between items-center">
            <span>Products ({{ orderFull.productsQuantity }} Items)</span>
            <span v-if="showPicking">
              {{ pickedCount }}/{{ orderFull.items.length }} picked
            </span>
          </div>
          <div class="content">
            <div class="table">
              <table class="default-table">
                <thead>
                  <tr>
                    <th>SKU</th>
                    <th>Description</th>
                    <th>Price</th>
                    <th>quantity</th>
                    <th>line</th>
                    <th>Stock</th>
                    <th>Location</th>
                    <th v-if="showPicking">Picked</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in orderFull.items" :key="item.uuid">
                    <td>
                      {{ `${item.productCode} ` }}
                    </td>
                    <td>
                      {{ `${item.description}` }}
                      <br />
                      {{ item.stockFull }}
                    </td>
                    <td>
                      {{ `$${item.price}` }}
                    </td>
                    <td>
                      {{ `${item.quantity} pcs` }}
                    </td>
                    <td>
                      {{ `${item.lineCode}` }}
                    </td>
                    <td>
                      {{ `${item.stock} pcs*` }}
                    </td>
                    <td>
                      {{
                        pickedState[item.uuid] && pickedState[item.uuid].picked
                          ? pickedState[item.uuid].location
                          : item.location
                      }}
                    </td>
                    <td v-if="showPicking">
                      <span
                        v-if="
                          pickedState[item.uuid] &&
                            pickedState[item.uuid].picked
                        "
                        class="success-text"
                      >
                        &#10003;
                      </span>
                      <button
                        v-else
                        class="dark-button text-xs px-2"
                        @click="confirmManualPick(item)"
                      >
                        Pick
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
              <p class="my-2 text-xs">
                * stock when the order was placed
              </p>
            </div>
          </div>
          <div class="content" v-if="showPicking">
            <button
              class="dark-button"
              :disabled="allPicked"
              @click="startGuidedScan"
            >
              Start Scanning
            </button>
          </div>
        </div>

        <div class="custom-box" v-if="showPicking">
          <div class="box-header">Dispatch &amp; Confirm Pick</div>
          <div class="content" style="width: 100%">
            <select v-model="dispatchWarehouseId" class="warehouse-select">
              <option value="">-- Select deposito --</option>
              <option
                v-for="dep in depositos"
                :key="dep.depositoId"
                :value="dep.depositoId"
              >
                {{ dep.codDeposito }} — {{ dep.descDeposito || dep.depositoId }}
              </option>
            </select>
            <button
              class="dark-button mt-4"
              :disabled="!dispatchWarehouseId || !allPicked || dispatching"
              @click="generateMovementsAndConfirm"
            >
              {{
                dispatching
                  ? "Processing..."
                  : "Generate Movements & Confirm Pick"
              }}
            </button>
          </div>
        </div>
        <div
          v-if="orderFull.shipments && orderFull.shipments.length > 0"
          class="custom-box"
        >
          <div class="box-header">
            <span>Shipments</span>
          </div>
          <div class="content">
            <table class="default-table">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>carrier</th>
                  <th>service</th>
                  <th>tracking</th>
                  <th>label cost</th>
                  <th>insurance cost</th>
                  <th>sync</th>
                  <th>status</th>
                  <th></th>
                </tr>
              </thead>
              <tr v-for="shipment in orderFull.shipments" :key="shipment.uuid">
                <td>
                  {{ shipment.dateShipped }}
                </td>
                <td>
                  {{ shipment.carrier }}
                </td>
                <td>
                  {{ shipment.service }}
                </td>
                <td>
                  {{ shipment.tracking }}
                </td>
                <td>
                  {{ shipment.labelCost }}
                </td>
                <td>
                  {{ shipment.insuranceCost }}
                </td>
                <td>
                  {{ shipment.sourceSync == "1" ? "Yes" : "No" }}
                </td>
                <td>
                  <span v-if="shipment.voided == 1" class="text-red-600"
                    >Voided</span
                  >
                  <span v-else>Active</span>
                </td>
                <td>
                  <button
                    v-if="shipment.voided != 1 && shipment.labelUrl"
                    class="dark-button text-xs mr-1 px-2"
                    :disabled="printingShipmentUuid === shipment.uuid"
                    @click="printShipmentLabel(shipment)"
                  >
                    {{
                      printingShipmentUuid === shipment.uuid
                        ? "Sending..."
                        : "Print"
                    }}
                  </button>
                  <button
                    v-if="shipment.voided != 1 && shipment.labelId"
                    class="dark-button text-xs px-2"
                    :disabled="voidingShipmentUuid === shipment.uuid"
                    @click="voidShipmentLabel(shipment)"
                  >
                    {{
                      voidingShipmentUuid === shipment.uuid
                        ? "Voiding..."
                        : "Void"
                    }}
                  </button>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div
          class="custom-box"
          v-if="orderFull.exportStatus.length > 0 || orderFull.logs.length > 0"
        >
          <div class="box-header">
            Order History
          </div>
          <div>
            <div class="text-red-500 flex-grow">
              <div
                class="px-4 font-bold"
                v-for="print in orderFull.printed"
                :key="print.uuid"
              >
                Printed in warehouse on {{ print.date | dateWithHours }}
              </div>
            </div>
          </div>
          <div class="content">
            <div>
              Export Status
              <br />
              <table class="default-table">
                <thead>
                  <tr>
                    <th>System</th>
                    <th>System order id</th>
                    <th>Type</th>
                    <th>Date</th>
                    <th>Status</th>
                    <th>User</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="exportItem in orderFull.exportStatus"
                    :key="exportItem.uuid"
                  >
                    <td>{{ exportItem.name }}</td>
                    <td>{{ exportItem.integratedSystemOrderId }}</td>
                    <td>{{ exportItem.type }}</td>
                    <td>{{ exportItem.date }}</td>
                    <td>{{ exportItem.status }}</td>
                    <td>{{ exportItem.user }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div>
              Logs
              <table class="default-table">
                <thead>
                  <tr>
                    <th>Message</th>
                    <th style="width: 140px">Date</th>
                    <th style="width: 80px">Status</th>
                    <th style="width: 80px">User</th>
                  </tr>
                </thead>
                <tr v-for="log in orderFull.logs" :key="log.uuid">
                  <td>
                    {{ log.message }}
                  </td>
                  <td>
                    {{ log.date }}
                  </td>
                  <td>
                    {{ log.success == "1" ? "Success" : "Error" }}
                  </td>
                  <td>
                    {{ log.user }}
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
        <div class="custom-box" v-if="actions.length > 0">
          <div class="box-header">Action History</div>
          <div class="content">
            <table class="default-table">
              <thead>
                <tr>
                  <th>Action</th>
                  <th>Date</th>
                  <th>User</th>
                  <th>Details</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="action in actions" :key="action.id">
                  <td>{{ actionLabel(action.action) }}</td>
                  <td>{{ action.performedAt }}</td>
                  <td>{{ action.performedByName || action.performedBy }}</td>
                  <td>
                    <div
                      v-for="(val, key) in parseActionDetails(action.details)"
                      :key="key"
                      class="text-xs"
                    >
                      <b>{{ key }}:</b> {{ val }}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="custom-box">
          <div class="box-header">Payments</div>
          <div class="content">
            <table class="default-table">
              <thead>
                <tr>
                  <th>Cardholder name</th>
                  <th>Type</th>
                  <th>TransactionId</th>
                  <th>date</th>
                  <th>amount</th>
                  <th>comment</th>
                </tr>
              </thead>
              <tr v-for="payment in orderFull.payments" :key="payment.uuid">
                <td>
                  {{ payment.cardholderName }}
                </td>
                <td>
                  {{ payment.paymentType }}
                </td>
                <td>
                  {{ payment.transactionId }}
                </td>
                <td>
                  {{ payment.dateTransaction }}
                </td>
                <td>
                  {{ payment.amount }}
                </td>
                <td>
                  {{ payment.comment }}
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="loading-full">
      <BaseSmallSpinner />
    </div>

    <AddressEditModal
      v-model="showAddressModal"
      :address="editAddressData"
      :addressType="editingAddressType"
      :isSaving="processing"
      :shippingAddress="orderFull.shippingAddress"
      @save="saveAddress(editingAddressType, $event)"
    />

    <!-- Guided scan overlay: works with USB/bluetooth barcode scanners (act as keyboard input) -->
    <div v-if="scanning" class="scan-overlay">
      <div class="scan-box">
        <div class="flex justify-between items-center mb-2">
          <span>{{
            scanMode === "location"
              ? "Scan location barcode"
              : "Scan product barcode"
          }}</span>
          <button class="close-scan" @click="stopScan">x</button>
        </div>
        <div class="text-xs mb-2" v-if="scanMode === 'product'">
          {{ remainingCount }} item(s) remaining
        </div>
        <input
          ref="scanInput"
          v-model="scanBuffer"
          class="scan-input"
          autofocus
          placeholder="Scan or type code and press Enter"
          @keyup.enter="onScanSubmit"
        />
      </div>
    </div>

    <!-- Pick confirmation dialog -->
    <div v-if="showPickConfirm && pickConfirmItem" class="scan-overlay">
      <div class="scan-box">
        <div class="flex justify-between items-center mb-2">
          <span>Confirm Pick</span>
          <button class="close-scan" @click="cancelPickConfirm">x</button>
        </div>
        <div class="mb-2">
          <b>{{ pickConfirmItem.productCode }}</b>
          <br />
          {{ pickConfirmItem.description }}
        </div>
        <div class="mb-2">
          <label>Quantity</label>
          <div class="flex items-center gap-2">
            <button
              class="dark-button px-2"
              :disabled="pickQty <= 1"
              @click="pickQty--"
            >
              -
            </button>
            <input
              type="number"
              v-model.number="pickQty"
              min="1"
              class="scan-input"
              style="width: 80px"
            />
            <button class="dark-button px-2" @click="pickQty++">+</button>
          </div>
        </div>
        <div class="mb-2">
          <label>Location</label>
          <div class="flex items-center gap-2">
            <input
              v-model="pickedLocation"
              class="scan-input"
              placeholder="Scan or type location"
            />
            <button class="dark-button px-2" @click="scanLocationForPick">
              Scan
            </button>
          </div>
        </div>
        <button
          class="dark-button mt-4"
          :disabled="!pickedLocation || pickQty < 1"
          @click="acceptPickConfirm"
        >
          Confirm Pick
        </button>
      </div>
    </div>
  </BaseModal>
</template>
<script>
import {
  getOrder,
  sendOrder,
  updateOrder,
  forceSentToSystem,
  markOrderShippedApi,
  reverifyProductsApi
} from "@/api/SyncSystem.js";
import { createDispatchReceipt } from "@/api/DispatchReceiptService.js";
import PrintNodeApi from "@/api/PrintNode.js";
import ShippingApi from "@/api/Shipping.js";
import {
  updateOrderFromShipstation,
  updateOrderStatus,
  touchOrder,
  updateOrderAddress,
  dispatchOrder,
  confirmPick
} from "@/api/Orders.js";
import { getDepositos } from "@/api/Infoauto.js";

import OrderFlagData from "@/components/OrderFlagData.vue";
import OrderFlagButton from "@/components/OrderFlagButton.vue";
import AddressEditModal from "@/components/global/_base-address-edit-modal.vue";
export default {
  props: {
    orderUUID: {
      type: String,
      required: true
    },
    value: {
      type: Boolean,
      required: true
    }
  },
  components: {
    OrderFlagData,
    OrderFlagButton,
    AddressEditModal
  },
  data() {
    return {
      orderFull: null,
      processing: false,
      loading: true,
      isOpenModal: this.value,
      showOrderOptions: false,
      creatingDispatchReceipt: false,
      activeReceiptId: null,
      activeAddressTab: "shipping",
      showAddressModal: false,
      editingAddressType: null,
      editAddressData: {},
      printers: [],
      printingTest: false,
      printingOrder: false,
      printingShipmentUuid: null,
      voidingShipmentUuid: null,
      // Guided picking / scanning
      pickedState: {},
      scanning: false,
      scanMode: "product",
      scanBuffer: "",
      wasScanning: false,
      showPickConfirm: false,
      pickConfirmItem: null,
      pickQty: 1,
      pickedLocation: "",
      depositos: [],
      dispatchWarehouseId: "",
      dispatching: false
    };
  },
  computed: {
    showPicking() {
      return (
        this.orderFull &&
        this.orderFull.status == "awaiting_shipment" &&
        this.orderFull.warehouseStatus != "picking_confirmed" &&
        this.orderFull.warehouseStatus != "processed"
      );
    },
    pickedCount() {
      return Object.values(this.pickedState).filter(s => s.picked).length;
    },
    allPicked() {
      return (
        this.orderFull &&
        this.orderFull.items.length > 0 &&
        this.orderFull.items.every(
          i => this.pickedState[i.uuid] && this.pickedState[i.uuid].picked
        )
      );
    },
    remainingCount() {
      if (!this.orderFull) return 0;
      return this.orderFull.items.length - this.pickedCount;
    },
    printOrderUrl() {
      return `${process.env.VUE_APP_NKRSYNC_BE}orders/print_invoice/${this.orderUUID}`;
    },
    isOpen() {
      return this.value;
    },
    systems() {
      return this.$store.getters["general/getSystems"];
    },
    defaultPrinter() {
      return this.printers.find(p => p.default == 1) || null;
    },
    actions() {
      return (this.orderFull && this.orderFull.actions) || [];
    }
  },
  watch: {
    isOpenModal(val) {
      console.log("changed - isOpenModal");
      this.$emit("input", val);
    },
    value(val) {
      console.log(
        "changed - value",
        { val },
        "isOpenModal " + this.isOpenModal
      );

      if (val) {
        const query = { ...this.$route.query, orderOpen: this.orderUUID };
        if (JSON.stringify(query) !== JSON.stringify(this.$router.query)) {
          this.$router.replace({ query }).catch(() => {});
        } else {
          console.log("same so not");
        }
        this.showOrderOptions = false;
        this.orderFull = null;
        this.getOrder();
      } else {
        console.log("no val");
        const query = { ...this.$route.query };
        delete query.orderOpen;
        this.$router.replace({ query }).catch(() => {});
      }
      this.isOpenModal = val;
    }
    // orderUUID(val) {
    //   if (this.orderFull && this.orderFull.uuid == val) return;
    //   console.log("orderUUID");
    //   if (val != "") {
    //     this.orderFull = null;
    //     this.getOrder();
    //   }
    // }
  },
  methods: {
    actionLabel(action) {
      switch (action) {
        case "warehouse_movement_confirmed":
          return "Warehouse Movement Confirmed";
        case "picking_confirmed":
          return "Picking Confirmed";
        case "label_created":
          return "Label Created";
        case "label_voided":
          return "Label Voided";
        case "shipping_selected":
          return "Shipping Selected";
        default:
          return action.replace(/_/g, " ");
      }
    },
    parseActionDetails(details) {
      if (!details) return {};
      try {
        const parsed = JSON.parse(details);
        const result = {};
        for (const [key, val] of Object.entries(parsed)) {
          result[key] =
            Array.isArray(val) && val.length > 5 ? `${val.length} items` : val;
        }
        return result;
      } catch (e) {
        return {};
      }
    },
    createDispatchReceipt() {
      if (this.creatingDispatchReceipt) return;
      this.creatingDispatchReceipt = true;
      createDispatchReceipt(this.orderUUID)
        .then(receiptCreated => {
          this.$toast.open({
            message: "Dispatch receipt created",
            type: "success",
            position: "top-right"
          });
          this.getOrder();
          console.log(receiptCreated);
          this.activeReceiptId = receiptCreated.id;
        })
        .catch(() => {
          this.$toast.open({
            message: "Error creating dispatch receipt",
            type: "error",
            position: "top-right"
          });
        })
        .finally(() => {
          this.creatingDispatchReceipt = false;
        });
    },
    flagOrder() {},
    OrderSystemStatus(systemUUID) {
      const found = this.orderFull.exportStatus.find(element => {
        return (
          element.integratedSystemUuid === systemUUID &&
          element.status === "success"
        );
      });
      return found ? true : false;
    },
    closeOrder() {
      this.$emit("input", false);
    },
    async getOrder() {
      this.orderFull = await getOrder(this.orderUUID);
      this.loading = false;
      this.pickedState = {};
      this.dispatchWarehouseId = "";
      if (this.showPicking) {
        this.loadDepositos();
      }
    },
    async loadDepositos() {
      try {
        const res = await getDepositos();
        const all = Array.isArray(res) ? res : [];
        this.depositos =
          this.orderFull && this.orderFull.departamentoId
            ? all.filter(d => d.departamentoId == this.orderFull.departamentoId)
            : all;
      } catch (e) {
        this.depositos = [];
      }
    },
    findPickableItemByCode(code) {
      return this.orderFull.items.find(
        i =>
          i.productCode == code &&
          !(this.pickedState[i.uuid] && this.pickedState[i.uuid].picked)
      );
    },
    startGuidedScan() {
      if (this.allPicked) {
        this.$toast.open({
          message: "All items already picked",
          type: "info",
          position: "top-right"
        });
        return;
      }
      this.scanMode = "product";
      this.scanBuffer = "";
      this.scanning = true;
      this.$nextTick(() => {
        if (this.$refs.scanInput) this.$refs.scanInput.focus();
      });
    },
    stopScan() {
      this.scanning = false;
      this.scanBuffer = "";
    },
    scanLocationForPick() {
      this.wasScanning = false;
      this.showPickConfirm = false;
      this.scanMode = "location";
      this.scanBuffer = "";
      this.scanning = true;
      this.$nextTick(() => {
        if (this.$refs.scanInput) this.$refs.scanInput.focus();
      });
    },
    onScanSubmit() {
      const code = this.scanBuffer.trim();
      this.scanBuffer = "";
      if (!code) return;

      if (this.scanMode === "location") {
        this.pickedLocation = code;
        this.scanning = false;
        this.showPickConfirm = true;
        return;
      }

      const matchedItem = this.findPickableItemByCode(code);
      if (matchedItem) {
        this.wasScanning = true;
        this.scanning = false;
        this.openPickConfirm(matchedItem);
      } else {
        const alreadyPicked = this.orderFull.items.find(
          i =>
            i.productCode == code &&
            this.pickedState[i.uuid] &&
            this.pickedState[i.uuid].picked
        );
        this.$toast.open({
          message: alreadyPicked
            ? `${code} already picked`
            : `${code} not found in this order`,
          type: alreadyPicked ? "info" : "error",
          position: "top-right"
        });
      }
    },
    confirmManualPick(item) {
      this.wasScanning = false;
      this.openPickConfirm(item);
    },
    openPickConfirm(item) {
      this.pickConfirmItem = item;
      this.pickedLocation = item.location || "";
      this.pickQty = Number(item.quantity) || 1;
      this.showPickConfirm = true;
    },
    acceptPickConfirm() {
      if (this.pickConfirmItem && this.pickedLocation) {
        this.$set(this.pickedState, this.pickConfirmItem.uuid, {
          picked: true,
          location: this.pickedLocation,
          quantity: this.pickQty
        });
        this.$toast.open({
          message: `${this.pickConfirmItem.productCode} — ${this.pickQty} picked from ${this.pickedLocation}`,
          type: "success",
          position: "top-right"
        });
      }
      this.showPickConfirm = false;
      this.pickConfirmItem = null;
      this.pickedLocation = "";
      this.pickQty = 1;

      if (this.allPicked) {
        this.wasScanning = false;
        this.scanning = false;
        return;
      }
      if (this.wasScanning) {
        this.wasScanning = false;
        this.scanning = true;
        this.$nextTick(() => {
          if (this.$refs.scanInput) this.$refs.scanInput.focus();
        });
      }
    },
    cancelPickConfirm() {
      this.showPickConfirm = false;
      this.pickConfirmItem = null;
      this.pickedLocation = "";
      this.pickQty = 1;
      if (this.wasScanning) {
        this.wasScanning = false;
        this.scanning = true;
        this.$nextTick(() => {
          if (this.$refs.scanInput) this.$refs.scanInput.focus();
        });
      }
    },
    async generateMovementsAndConfirm() {
      if (!this.dispatchWarehouseId || !this.allPicked) return;
      this.dispatching = true;
      try {
        await dispatchOrder(this.orderUUID, this.dispatchWarehouseId);
        const pickedItems = this.orderFull.items.map(i => ({
          product_code: i.productCode,
          picked_location: (this.pickedState[i.uuid] || {}).location || ""
        }));
        await confirmPick(this.orderUUID, pickedItems);
        await this.getOrder();
        this.$toast.open({
          message: "Movements generated & picking confirmed",
          type: "success",
          position: "top-right"
        });
      } catch (e) {
        this.$toast.open({
          message: "Failed to process order",
          type: "error",
          position: "top-right"
        });
      } finally {
        this.dispatching = false;
      }
    },
    async sendToSystem(systemCode) {
      this.sendingOrder = true;
      this.processing = true;
      try {
        const sendOrderResult = await sendOrder(this.orderUUID, systemCode);
        if (sendOrderResult?.results?.ordersSentSuccess > 0) {
          this.$toast.open({
            message: "Order Sent",
            type: "success",
            position: "top-right"
          });
        } else {
          const error = sendOrderResult.message || "(check logs)";
          this.$toast.open({
            message: "Error Sending Order: " + error,
            type: "error",
            position: "top-right"
          });
        }
        this.processing = false;
      } catch (e) {
        this.processing = false;
        this.$toast.open({
          message: "Error on request",
          type: "error",
          position: "top-right"
        });
      }
      this.getOrder();
    },
    async forceSentToSystem(systemUUID) {
      this.sendingOrder = true;
      const sendOrderResult = await forceSentToSystem(
        this.orderUUID,
        systemUUID
      );
      if (sendOrderResult.exports) {
        this.orderFull.exportStatus = sendOrderResult.exports;
      }
      return sendOrderResult;
    },
    async changeExportEnable(newStatus) {
      const updated = await updateOrder(this.orderUUID, {
        export_enabled: newStatus
      });
      if (updated.status == "success") {
        this.orderFull.exportEnabled = newStatus;
      }
    },
    reverifyProducts() {
      this.loading = true;
      reverifyProductsApi(this.orderUUID)
        .then(() => {
          this.$toast.open({
            message: "Products reverified",
            type: "success",
            position: "top-right"
          });
          this.getOrder();
          this.loading = false;
          this.showOrderOptions = false;
        })
        .catch(() => {
          this.$toast.open({
            message: "Error reverifying products",
            type: "error",
            position: "top-right"
          });
          this.loading = false;
        });
    },
    updateFromShipstation() {
      this.loading = true;
      updateOrderFromShipstation(this.orderUUID)
        .then(() => {
          this.$toast.open({
            message: "Order updated from ShipStation",
            type: "success",
            position: "top-right"
          });
          this.getOrder();
          this.loading = false;
          this.showOrderOptions = false;
        })
        .catch(() => {
          this.$toast.open({
            message: "Error updating from ShipStation",
            type: "error",
            position: "top-right"
          });
          this.loading = false;
        });
    },
    touchOrderAction() {
      this.loading = true;
      touchOrder(this.orderUUID)
        .then(() => {
          this.$toast.open({
            message: "Order touched successfully",
            type: "success",
            position: "top-right"
          });
          this.getOrder();
          this.loading = false;
          this.showOrderOptions = false;
        })
        .catch(() => {
          this.$toast.open({
            message: "Error touching order",
            type: "error",
            position: "top-right"
          });
          this.loading = false;
        });
    },
    changeOrderStatus(status) {
      const confirmMessage =
        status === "cancelled"
          ? "Are you sure you want to cancel this order?"
          : "Are you sure you want to mark this order as shipped?";

      if (!confirm(confirmMessage)) return;

      this.processing = true;
      updateOrderStatus(this.orderUUID, status)
        .then(() => {
          this.$toast.open({
            message: `Order marked as ${status}`,
            type: "success",
            position: "top-right"
          });
          this.getOrder();
          this.$emit("orderStatusUpdated");
        })
        .catch(() => {
          this.$toast.open({
            message: "Error updating order status",
            type: "error",
            position: "top-right"
          });
        })
        .finally(() => {
          this.processing = false;
        });
    },
    markOrderShipped() {
      this.processing = true;
      markOrderShippedApi(this.orderUUID)
        .then(() => {
          this.orderFull.status = "shipped";
          this.showOrderOptions = false;
          this.$toast.open({
            message: "Order updated",
            type: "success",
            position: "top-right"
          });
          this.$emit("orderStatusUpdated");
        })
        .catch(() => {
          alert("error");
          this.$toast.open({
            message: "Error updating order",
            type: "error",
            position: "top-right"
          });
        });
    },
    async voidShipmentLabel(shipment) {
      if (
        !window.confirm(
          `Void label ${shipment.tracking}? This cannot be undone.`
        )
      ) {
        return;
      }
      this.voidingShipmentUuid = shipment.uuid;
      try {
        await ShippingApi.voidLabel(shipment.uuid);
        this.$toast.open({
          message: "Label voided",
          type: "success",
          position: "top-right"
        });
        this.getOrder();
        this.$emit("orderStatusUpdated");
      } catch (err) {
        const msg =
          err.response && err.response.data && err.response.data.message
            ? err.response.data.message
            : "Error voiding label";
        this.$toast.open({
          message: msg,
          type: "error",
          position: "top-right"
        });
      } finally {
        this.voidingShipmentUuid = null;
      }
    },
    async printShipmentLabel(shipment) {
      this.printingShipmentUuid = shipment.uuid;
      try {
        await PrintNodeApi.printLabel(shipment.uuid);
        this.$toast.open({
          message: "Label sent to printer",
          type: "success",
          position: "top-right"
        });
      } catch (err) {
        const msg =
          err.response && err.response.data && err.response.data.error
            ? err.response.data.error
            : "Error sending label to printer";
        this.$toast.open({
          message: msg,
          type: "error",
          position: "top-right"
        });
      } finally {
        this.printingShipmentUuid = null;
      }
    },
    async printOrderWithPrintNode() {
      this.printingOrder = true;
      this.showOrderOptions = false;
      try {
        await PrintNodeApi.printOrder(this.orderUUID);
        this.$toast.open({
          message: "Order sent to printer",
          type: "success",
          position: "top-right"
        });
      } catch (err) {
        const msg =
          err.response && err.response.data && err.response.data.error
            ? err.response.data.error
            : "Error sending to printer";
        this.$toast.open({
          message: msg,
          type: "error",
          position: "top-right"
        });
      } finally {
        this.printingOrder = false;
      }
    },
    startEditAddress(addressType) {
      this.editingAddressType = addressType;
      const address =
        addressType === "shipping"
          ? this.orderFull.shippingAddress
          : this.orderFull.billingAddress;
      // Deep clone the address to create a proper temp object
      this.editAddressData = JSON.parse(
        JSON.stringify({
          name: address.name || "",
          company: address.company || "",
          street1: address.street1 || "",
          street2: address.street2 || "",
          street3: address.street3 || "",
          city: address.city || "",
          state: address.state || "",
          postalCode: address.postalCode || "",
          postal_code: address.postalCode || "",
          country: address.country || "",
          phone: address.phone || "",
          residential: address.residential ? 1 : 0,
          address_verified: address.address_verified ? 1 : 0
        })
      );
      this.showAddressModal = true;
    },
    cancelEditAddress() {
      this.showAddressModal = false;
      this.editingAddressType = null;
      this.editAddressData = {};
    },
    updateEditAddress(updatedData) {
      this.editAddressData = updatedData;
    },
    async saveAddress(addressType, formData) {
      this.processing = true;
      try {
        // Use the formData passed from the form component
        const addressData = formData || this.editAddressData;
        const payload = {
          type: addressType === "shipping" ? "s" : "b",
          name: addressData.name,
          company: addressData.company,
          street1: addressData.street1,
          street2: addressData.street2,
          street3: addressData.street3,
          city: addressData.city,
          state: addressData.state,
          postal_code: addressData.postalCode || addressData.postal_code,
          country: addressData.country,
          phone: addressData.phone,
          residential: addressData.residential ? 1 : 0,
          address_verified: addressData.address_verified ? 1 : 0
        };

        await updateOrderAddress(this.orderUUID, payload);

        this.$toast.open({
          message: `${
            addressType === "shipping" ? "Shipping" : "Billing"
          } address updated successfully`,
          type: "success",
          position: "top-right"
        });

        this.showAddressModal = false;
        this.editingAddressType = null;
        this.editAddressData = {};
        await this.getOrder();
      } catch (error) {
        this.$toast.open({
          message: `Error updating address: ${error.message}`,
          type: "error",
          position: "top-right"
        });
      } finally {
        this.processing = false;
      }
    }
  }
};
</script>
<style lang="postcss" scoped>
.list-button {
  @apply w-full border-white border p-4 text-gray-200 hover:bg-gray-400 hover:text-white;
}

.tab-button {
  @apply px-4 py-2 mx-1 bg-gray-400 text-white rounded hover:bg-gray-500 transition;
}

.tab-button.active {
  @apply bg-gray-700;
}

.address-form {
  padding: 10px;
}

.address-box {
  padding: 10px 0;
}

.mt-4 {
  margin-top: 1rem;
}

.alert {
  background-color: #fff3cd;
  border: 1px solid #ffc107;
  padding: 10px;
  border-radius: 4px;
  margin-top: 10px;
}

.alert p {
  margin: 0;
  color: #856404;
}

.flex {
  display: flex;
}

.justify-between {
  justify-content: space-between;
}

.items-center {
  align-items: center;
}

.gap-2 {
  gap: 0.5rem;
}

.warehouse-select {
  width: 100%;
  padding: 8px;
  border: 1px solid grey;
  border-radius: 4px;
}

.scan-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.scan-box {
  background: white;
  border-radius: 6px;
  padding: 20px;
  width: 90%;
  max-width: 420px;
}

.scan-input {
  width: 100%;
  padding: 10px;
  font-size: 16px;
  border: 1px solid grey;
  border-radius: 4px;
}

.close-scan {
  background: transparent;
  border: none;
  cursor: pointer;
  font-weight: bold;
}
</style>
<style lang="scss">
@import "@/assets/style/css/generic-variables.scss";
.loading-full {
  height: 100%;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.order-modal {
  &.modal {
    padding-top: 10px;
    .modal-content {
      height: 97%;
      width: 96%;
      max-width: 1600px;
      margin: 0 auto;
      padding: 0px;
    }
  }
}
@media (max-width: 768px) {
  .order-modal {
    &.modal {
      padding-top: 0px;
      .modal-content {
        height: 100%;
        width: 100%;
        max-width: none;
      }
    }
  }
}
.order-view {
  height: 100%;
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .header {
    flex: 0 0 auto;
    position: relative;
    height: 60px;
    background-color: #80808038;
    color: white;
    .info {
      height: 100%;
      align-content: center;
      color: black;
      padding: 20px;
      display: flex;
      flex-direction: row;
      gap: 10px;
      span {
        font-weight: bold;
      }
    }
    .close-link {
      position: absolute;
      right: 10px;
      top: 10px;
      width: 30px;
      height: 30px;
      a {
        width: 100%;
      }
    }
  }
  .content {
    padding: 5px 10px 20px;
    width: 100%;
    box-sizing: border-box;
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    position: relative;
    align-content: flex-start;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    gap: 10px;
    .box {
      flex: 1 1 320px;
      min-width: 280px;
      max-width: 100%;
      box-sizing: border-box;
      border: 1px solid grey;
      border-radius: 5px;
      .box-header {
        width: 100%;
        padding: 5px 10px;
        background-color: grey;
        color: white;
        box-sizing: border-box;
      }
      .box-content {
        width: 100%;
        padding: 5px 10px;
        box-sizing: border-box;
      }
      table {
        width: 100%;
      }
    }
    .product-box,
    .custom-box {
      width: 100%;
      flex: 1 1 100%;
      margin-top: 10px;
      border: 1px solid black;
      border-radius: 5px;
      min-height: 200px;
      box-sizing: border-box;
      .box-header {
        width: 100%;
        padding: 5px 10px;
        background-color: grey;
        color: white;
        box-sizing: border-box;
      }
      .content {
        padding: 10px;
        box-sizing: border-box;
      }
      .table {
        width: 100%;
        overflow-x: auto;
        table {
          min-width: 600px;
        }
      }
    }
    .custom-box {
      .content {
        div {
          width: 45%;
        }
      }
    }
  }
  @media (max-width: 768px) {
    .content {
      .box {
        flex: 1 1 100%;
      }
      .custom-box {
        .content {
          div {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>
